import { TOfferType } from '@/features';

export const prepareProductGroupToPost = ({ name, showImmediately, image }: TOfferType) => ({
  name,
  description: { en: '', cs: '', de: '' },
  short_description: undefined,
  image_id: image,
  ordering: undefined,
  is_active: showImmediately,
});
